async function copyToClipboard(value: string | undefined) {
  if (!value) return false
  await navigator.clipboard.writeText(value)
}

export default copyToClipboard
